// `{'@'}` is vue-i18n's literal: a bare `@` starts a linked message and fails to compile.
export default {
  sectionTitle: 'Proof of payment by email',
  channel: {
    title: 'Receive proofs of payment by email',
    rule: "Turning this on gives your organisation its own address, which your banks email proofs of payment to. The address is made from your organisation's name and stays the same once issued.",
    on: 'Receiving proofs by email: On',
    off: 'Receiving proofs by email: Off',
    unsavedChanges: 'Save or undo your changes below before turning this off.',
    failed: {
      on: 'Proof of payment by email was not turned on. Try again.',
      off: 'Proof of payment by email was not turned off. Try again.',
    },
    turnOffDialog: {
      title: 'Stop receiving proofs by email?',
      notAccepted: 'Proofs emailed to your address will no longer be accepted.',
      awaitingPayments:
        'Payments waiting for an emailed proof will need their proof uploaded instead.',
      turnBackOn: 'Turning it back on restores the same address and senders.',
      confirm: 'Turn off',
      cancel: 'Keep it on',
    },
  },
  proofAddress: {
    label: 'Proofs are emailed to',
    copyLabel: 'proof address',
  },
  forwarding: {
    subHeader: 'Forwarding',
    title: 'Forward each proof to our finance administrators',
    rule: 'When a proof arrives from an accepted sender, a copy with the document attached goes to every Org Finance Admin in this organisation. If the organisation has no Org Finance Admin, nothing is sent. Proofs from senders who are not accepted are never forwarded.',
    on: 'Forwarding: On',
    off: 'Forwarding: Off',
  },
  senders: {
    subHeader: 'Who can send proofs',
    intro:
      'Proofs are read only when they come from a sender listed here. A proof from anyone else is kept on Unmatched proofs as Sender not recognised, and nothing is matched from it.',
    foot: 'A change applies to proofs that arrive after you save. A proof already on Unmatched proofs as Sender not recognised needs its reading retried there.',
  },
  financeUsers: {
    title: 'Your finance users',
    lock: 'Everyone with the Org Finance Officer or Org Finance Admin role is listed here automatically. This list follows their roles: it changes when a role changes in Users, and is checked every hour. They cannot be removed here.',
    columns: {
      sender: 'Sender',
      name: 'Name',
      roles: 'Finance roles',
      status: 'Status',
    },
    followsRoles: 'Follows roles',
    roles: {
      ORG_FO: 'Org Finance Officer',
      ORG_FA: 'Org Finance Admin',
    },
  },
  addresses: {
    title: 'Addresses you accept proofs from',
    count: '{count} addresses',
    column: 'Address',
    fieldLabel: 'Email address',
    fieldHelp:
      "One exact address, such as statements{'@'}fnb.co.za. No * here: to accept a whole domain, add the domain.",
    add: 'Add address',
    emptyDraft: 'Enter an address to add.',
    unaddedDraft: 'Add this address, or clear the field, before you save.',
    overLimit: 'You can list up to {limit} addresses. Remove {excess} to save.',
  },
  domains: {
    title: 'Domains you accept proofs from',
    count: '{count} domains',
    column: 'Domain',
    readingColumn: 'What it accepts',
    fieldLabel: 'Domain',
    fieldHelp:
      'Enter a domain, such as fnb.co.za, to accept senders at that domain only. Enter a wildcard, such as *.fnb.co.za, to accept every domain below it (mail.fnb.co.za, alerts.mail.fnb.co.za) but never fnb.co.za itself. To accept both, add both. The * can only be the whole first part, followed by a dot.',
    add: 'Add domain',
    emptyDraft: 'Enter a domain to add.',
    unaddedDraft: 'Add this domain, or clear the field, before you save.',
    overLimit: 'You can list up to {limit} domains. Remove {excess} to save.',
    reading: {
      exact: 'Accepts senders at {domain} only',
      wildcard:
        'Accepts every domain ending in .{parent}, such as mail.{parent}. Not {parent} itself.',
    },
  },
  rows: {
    actionColumn: 'Action',
    remove: 'Remove',
    removeLabel: 'Remove {value}',
    undo: 'Undo',
    undoLabel: 'Undo removing {value}',
    added: 'Not saved yet',
    removed: 'Removed, not saved yet',
    storedEarlier: 'Stored earlier',
  },
  noOtherSenders: {
    title: 'No other senders yet',
    description:
      'Only proofs from your finance users above are read. Until you add your bank here, its proofs land on Unmatched proofs as Sender not recognised.',
  },
  loading: 'Loading proof settings',
  readFailed:
    'We could not load your proof settings, so we cannot show who your proofs are accepted from.',
  retry: 'Try again',
  saved: 'Proof settings saved. They apply to proofs that arrive from now on.',
  saveFailed: 'Your changes were not saved. Check your connection and save again.',
  viewOnly:
    'You can see these settings but not change them. To add a sender, ask an Organisation Admin or an Org Finance Officer.',
  viewOnlyChannelOff:
    'You can see this setting but not change it. To turn it on, ask an Organisation Admin or an Org Finance Officer.',
  phone: 'Change these settings on a larger screen.',
  leaveDialog: {
    title: 'Leave without saving?',
    body: 'Your changes to proof settings will be lost.',
    confirm: 'Leave',
    cancel: 'Keep editing',
  },
};
